import { Coordinates } from '@property/shared';
import { useStaticMap } from '@/hooks/use-static-map';
import { Skeleton } from '@/components/ui/skeleton';
import { useTheme } from '@/hooks/use-theme';
import { cn } from '@/lib/utils';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

interface StaticMapProps {
  center: Coordinates;
  zoom?: number;
  className?: string;
  showUserLocation?: boolean;
}

export function StaticMap({
  center,
  zoom = 17,
  className = '',
  showUserLocation = true,
}: StaticMapProps) {
  const { theme } = useTheme();

  // Determine if dark mode is active
  const isDarkMode = theme === 'dark';

  const { mapRef, isReady } = useStaticMap({
    apiKey: GOOGLE_MAPS_API_KEY,
    center,
    zoom,
    isDarkMode,
    showUserLocation,
  });

  return (
    <div className={cn('relative', className)}>
      {!isReady && <Skeleton className="absolute inset-0 rounded-lg" />}
      <div ref={mapRef} className="w-full h-full rounded-lg" style={{ minHeight: '200px' }} />
    </div>
  );
}
